import axios from 'axios';

const API_VERSION = 1;

const ENV = process.env.REACT_APP_NODE_ENV === 'production' ? 'prod' : 'dev';
const AWS_URL = `${process.env.REACT_APP_AWS_BASE_URL}${ENV}/v${API_VERSION}/`;

export const awsInstance = axios.create({
  baseURL: AWS_URL,
  headers: { 'x-api-key': process.env.REACT_APP_AWS_KEY }
});
